import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MaxExposedPlayersSalaryValidator extends BaseValidator {
    private maxSalary: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.maxSalary = sportConfig.getConfigProp('maxSalary', 0);

        if (this.isSalaryExceeded()) {
            this.addError('The total salary of your minimum exposure players exceeds the salary cap, please adjust.');
        }
    }

    private isSalaryExceeded(): boolean {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const exposedPlayersSalary = this.calcExposedPlayersSalary();

        return this.maxSalary <= exposedPlayersSalary;
    }

    private calcExposedPlayersSalary(): number {
        // @ts-ignore
        const {playersGroupedByExposureMin} = this.dependencies;

        const exposureValue = '100';

        let salary = 0;

        if (!(exposureValue in playersGroupedByExposureMin)) {
            return salary;
        }

        playersGroupedByExposureMin[exposureValue].map((player) => {
            salary += player.salary;
        });

        return salary;
    }
}

export {MaxExposedPlayersSalaryValidator};
